import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { useOrderAPackageContext } from '../../../OrderAPackageContext';
import { getFulfillmentInformationSummary } from '../../fulfillmentUtils';
import './FulfillmentCard.scss';

export const FulfillmentCard = () => {
  const { state } = useOrderAPackageContext();
  const { products } = state;
  let isPickUp = false;
  let isDelivery = false;
  isPickUp = getFulfillmentInformationSummary(products).some((product) => product.isPickUp);
  isDelivery = getFulfillmentInformationSummary(products).some((product) => product.isDelivery);

  if (!(isPickUp || isDelivery)) {
    return null;
  }

  return (
    <div className="fulfillment-card">
      <h2>Options available at checkout</h2>
      { (isPickUp || isDelivery) && (

        <div className="fulfillment-options">
          {isPickUp && (
            <div className="fulfillment-options-item">
              <Image
                className="fulfillment__icons"
                alt="store-pickup"
                height={24}
                width={24}
                src="https://assets.thdstatic.com/images/v1/In-Stock.svg"
              /> Store Pick Up
            </div>
          )}
          {isDelivery && (
            <div className="fulfillment-options-item">
              <Image
                className="fulfillment__icons"
                alt="delivery"
                height={24}
                width={24}
                src="https://assets.thdstatic.com/images/v1/truck-icon-green.svg"
              />
              <span className="fulfillment-options-item-span-color">FREE </span> Delivery
            </div>
          )}
        </div>
      )}
    </div>
  );
};

FulfillmentCard.displayName = 'FulfillmentCard';